import { FC } from 'react';

export type Props = {
  content?: string[];
};

export const Subtitle: FC<Props> = ({ content }) => {
  return (
    <>
      {content?.map((p, key) => (
        <span dangerouslySetInnerHTML={{ __html: p }} key={key} />
      ))}
    </>
  );
};
